export const adviceStudent = [
   {
     boldTitle: "Занурення:",
     text: "Пориньте в англомовне середовище. Слухайте англійську музику, дивіться фільми та серіали, читайте книги та новини англійською мовою. На ваших уроках ви знайдете все необхідне для цього.",
   },
   {
     boldTitle: "Практика спілкування:",
     text: "Використовуйте можливості спілкування з викладачами, щоб покращити вимову та розуміння розмовної англійської.",
   },
   {
     boldTitle: "Щоденна практика:",
     text: "Виділяйте хоча б 15-30 хвилин щодня на вивчення англійської. Регулярність допомагає краще засвоювати новий матеріал.",
   },
   {
     boldTitle: "Граматика та лексика:",
     text: "Працюйте над граматикою та лексикою паралельно. На ваших уроках з EnglishLoom ви знайдете структуровані курси з граматики та лексичний матеріал.",
   },
   {
     boldTitle: "Встановлення цілей:",
     text: "Встановлюйте конкретні, досяжні цілі для вивчення англійської. На платформі  ви можете відстежувати свій прогрес і бачити свої досягнення.",
   },
   {
     boldTitle: "Культурний контекст:",
     text: "Дізнавайтеся більше про англомовні країни та їх культуру на ваших уроках. Це допоможе вам краще розуміти контексти використання певних фраз та виразів.",
   },
];

export const rules = [
   {
      boldTitle: "Скасування/Перенесення Уроку:",
      text: "Скасувати/Перенести урок ви можете на сторінці 'Графік'",
    },
    {
      boldTitle: "Заміна Вчителя:",
      text: "У випадку відміни уроку викладачем, ми забезпечимо заміну викладача, або перенесемо урок на інший зручний для всіх день.",
    },
    {
      boldTitle: "Скасування Уроку та Відшкодування:",
      text: "Прохання скасовувати уроки щонайменше за 4 години до початку. В іншому випадку урок вважатиметься пройденим, за винятком непередбачуваних ситуацій. У разі бажання учня завершити навчання в нашій школі, проте залишаються оплачені уроки, варто зазначити, що гроші за залишкові уроки не підлягають поверненню. Однак у вас є можливість призупинити навчання і повернутися до нього у зручний для себе час.",
    },
    {
      boldTitle: "Запізнення та Відсутність Вчителя:",
      text: "Запізнення учня на урок не компенсується часом. У випадку відсутності вчителя без попередження, пропущений урок буде перенесений на інший зручний для вас час.",
    },
    {
      boldTitle: "Акція 'Приведи Друга':",
      text: "У нашій школі діє акція 'Приведи Друга'. Якщо ваш друг здійснить вступ на наші заняття за вашою рекомендацією, обидва отримаєте 2 безкоштовні уроки.",
    },
    {
      boldTitle: "Тривалість уроків:",
      text: "Учні до 12років - 45хв., 12+ років - 50хв.",
    },
    {
      boldTitle: "Технічна рекомендація:",
      text: "Рекомендуємо приєднуватись до уроків з ноутбука або комп'ютера. Якщо у вас Windows — бажано використовувати останню версію системи. Якщо Mac — також останню версію macOS. Рекомендуємо використовувати виключно браузер Google Chrome для найкращої якості зв'язку та стабільності.",
    }

]

export const newFeatureTitleStudent = "Зірки та магазин нагород"

export const newFeatureStudent = [
  {
    number: '1',
    text: 'За кожне здане домашнє завдання ти отримуєш зірку. Баланс видно вгорі сторінки.'
  },
  {
    number: '2',
    text: 'Обмінюй зірки в магазині на знижку на пакет або безкоштовний урок.'
  },
  {
    number: '3',
    text: 'Даруй другу пробний урок — якщо він почне навчання, ти отримаєш ще 20 зірок.'
  },
]
